import React from 'react';
import ReactMarkdown from 'react-markdown';
import { BotMessageSquare } from 'lucide-react';

const Message = ({ message, isLastBotMessage }) => {
  const cdnUrl = process.env.REACT_APP_CDN_URL || 'https://files.500kb.com';
  const botMessageWithCursor = isLastBotMessage ? `${message.text} ▐` : message.text;

  if (message.sender === "user") {
    return (
      <div className="flex flex-col items-end gap-2">
        {/* Images Section */}
        {message.files && message.files.length > 0 && (
          <div className="flex flex-row flex-wrap gap-2 justify-end max-w-[80%]">
            {message.files.map((file) => (
              <div key={file.file_uuid} className="w-[120px] h-[120px]">
                <img
                  src={`${cdnUrl}/${file.thumbnail_url}`}
                  alt="Uploaded content"
                  className="w-full h-full rounded-lg object-cover"
                />
              </div>
            ))}
          </div>
        )}
        
        {/* Message Text */}
        {message.text && (
          <div className="flex justify-end max-w-[80%]">
            <div className="px-4 py-2 rounded-lg bg-neutral-700 text-white">
              {message.text}
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex justify-start">
      <div className="flex items-start pt-2 mr-2" style={{ width: "28px", flexShrink: 0 }}>
        <BotMessageSquare className="text-white-200" size={28} />
      </div>
      <div className="flex-grow px-4 py-2 rounded-lg text-gray-100 flex items-start">
        <ReactMarkdown className="markdown">
          {isLastBotMessage ? botMessageWithCursor : message.text}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default Message;